import { IdName } from '@shared/models/id-name';

export interface IntuitiveImplantsFormValue {
	scanBodyManufacturer: IdName | null;
	implantManufacturer: IdName | null;
	implantTypeScanBody: IdName | null;
}

export const EMPTY_INTUITIVE_IMPLANTS_FORM_VALUE: IntuitiveImplantsFormValue = {
	scanBodyManufacturer: null,
	implantManufacturer: null,
	implantTypeScanBody: null
};
